export { ExtensionServiceOverride, default, setLocalExtensionHost } from './extensions.js';
export { ExtensionHostKind } from 'vscode/vscode/vs/workbench/services/extensions/common/extensionHostKind';
